import { defaultCurrency } from 'config/locale';
import { getBrowserLocale } from 'lib/locale';

/**
 * Format a numeric value as a currency using the specified locale
 *
 * @param {number} value Value to format
 * @param {string} currency Target currency
 */
export const formatCurrency = (value: number, currency = defaultCurrency) =>
  new Intl.NumberFormat(getBrowserLocale(), {
    currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(value);

/**
 * Format a numeric value using the specified locale
 *
 * @param {number} value Value to format
 */
export const formatNumber = (value: number) =>
  new Intl.NumberFormat(getBrowserLocale()).format(value);
